import { combineReducers } from 'redux'

import {
  SHOW_NO_URLS_ALLOWED_MODAL,
  HIDE_NO_URLS_ALLOWED_MODAL
} from 'src/actions/frontend'

const visible = (state = false, action) => {
  switch (action.type) {
    case SHOW_NO_URLS_ALLOWED_MODAL:
      return true
    case HIDE_NO_URLS_ALLOWED_MODAL:
      return false
    default:
      return state
  }
}

export default combineReducers({
  visible
})
